<template>
    <q-modal v-model="opened" :content-css="{maxWidth: '80vw', maxHeight: '80vh'}"
             @escape-key="$emit('close-terms-and-conditions')"
             @hide="$emit('close-terms-and-conditions')">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-toolbar-title class="text-center">
                    FORMULARIO DE PRÉSTAMO
                </q-toolbar-title>
            </q-toolbar>
            <div class="layout-padding">
                <div v-html="templateBody"></div>
                <v-checkbox path="optional"
                            v-model="form.guided_trial"
                            :extra-html="guidedTrialLabel"
                            :form="form"
                            class="col-12"
                            v-if="this.user.hasOwnProperty('enable_guided_trial') && this.user.enable_guided_trial">
                </v-checkbox>
                <v-checkbox path="accepted"
                            v-model="form.terms_and_conditions"
                            :extra-html="privacyLabel"
                            :form="form"
                            class="col-12">
                </v-checkbox>
                <v-checkbox path="optional"
                            v-model="form.follow_up"
                            :extra-html="optionalLabel"
                            :form="form"
                            class="col-12">
                </v-checkbox>
                <div class="col-12 row justify-center q-mt-md">
                    <v-button
                            class="no-shadow uppercase q-btn-iqos"
                            color="highlight"
                            @click="$emit('accept-terms-and-conditions')"
                            :label="$t('save')"></v-button>
                    <v-button
                            class="no-shadow uppercase q-btn-iqos"
                            style="margin-left: 15px;"
                            color="primary"
                            @click="$emit('close-terms-and-conditions')"
                            :label="$t('close')"></v-button>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import moment from 'moment'

    export default {
        name: "termsAndConditions",
        props: {
            form: Object,
            mockData: Object
        },
        data: () => ({
            template: '',
            templateNew: '',
            templateVariables: [],
            opened: true,
            columns: [
                {
                    name: 'value',
                    required: true,
                    label: 'Nº',
                    field: 'value',
                    align: 'left'
                },
                {
                    name: 'label',
                    required: true,
                    label: 'EQUIPAMIENTO',
                    field: 'label',
                    align: 'left'
                },
                {
                    name: 'sublabel',
                    required: true,
                    label: 'IDENTIFICATIÓN',
                    field: 'sublabel',
                    align: 'left'
                }
            ],
            columnsContacts: [
                {
                    name: 'name',
                    required: true,
                    label: 'CONTACTO',
                    field: 'name',
                    align: 'left'
                },
                {
                    name: 'contacts',
                    required: true,
                    label: 'DIRECCIÓN DE CORREO ELECTRÓNICO / NÚMERO DE TELEFÓNO',
                    field: 'contacts',
                    align: 'left'
                }
            ],
            pagination: {
                page: 1,
                rowsPerPage: 0
            }
        }),

        mounted() {
            this.templateVariables = this.mockData.templateVariables
            this.templateNew = this.user.market.templates.filter(t => {
                    if (this.user.lending_point.lending_point_type_id === t.lending_point_type_id) return t
                })[0]
            this.template = JSON.parse(JSON.stringify(this.templateNew))
        },

        methods: {
            updateTemplateVariableValues() {
                let kit = this.lendingKits.length ? this.lendingKits[0] : ''
                this.templateVariables['consumerFirstName'] = this.form.firstname;
                this.templateVariables['consumerLastName'] = this.form.lastname;
                this.templateVariables['consumerDNI'] = this.form.dni ? this.form.dni : '';
                this.templateVariables['consumerPhone'] = this.form.phone ? this.form.phone : '';
                this.templateVariables['consumerPrefix'] = this.form.phone_prefix ? this.form.phone_prefix : '';
                this.templateVariables['consumerEmail'] = this.form.email ? this.form.email : '';
                this.templateVariables['kitColor'] = kit.color;
                this.templateVariables['kitModel'] = kit.model;
                this.templateVariables['kitNumber'] = kit.value;
                this.templateVariables['kitCodentify'] = kit.codentify;
                this.templateVariables['kitCharger'] = kit.charger;
                this.templateVariables['kitHolder'] = kit.holder;
                this.templateVariables['DD'] = moment().format('DD');
                this.templateVariables['MM'] = moment().format('MM');
                this.templateVariables['YYYY'] = moment().format('YYYY');
                this.templateVariables['startLendingAt'] = moment().format('DD-MM-YYYY');
                this.templateVariables['endLendingAt'] = moment(this.form.end_lending_at, 'YYYY-MM-DD').format('DD-MM-YYYY');
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
            templateBody() {
                if (!this.template || !this.template.body) return 'No T&C template'

                this.updateTemplateVariableValues()

                this.template = JSON.parse(JSON.stringify(this.templateNew))

                Object.keys(this.templateVariables).filter(key => {
                    if (this.templateVariables[key] && this.templateVariables[key] !== ' ')
                        this.template.body = this.template.body.replace(new RegExp(key, "g"), this.templateVariables[key])
                })

                return this.template.body;
            },
            lendingKits() {
                let lendingKit = []
                this.mockData.lendingKits.forEach(item => {
                    if (item.id === this.form.lending_kit_id || this.form['lending_kit.codentify'] === item.codentify) {
                        lendingKit.push({
                            label: `${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}`,
                            value: item.id,
                            color: item.product_color ? item.product_color.description : '',
                            model: item.product_model ? item.product_model.description : '',
                            codentify: item.codentify,
                            charger: item.child_codentify_1,
                            holder: item.child_codentify_2,
                            sublabel: `${this.$T('codentify')}: ${item.codentify}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                        })
                    }
                })
                return lendingKit
            },
            prestamoContacts() {
                return [
                    {
                        name: `${this.mockData.lendingPointName}`,
                        contacts: ` / ${this.mockData.lendingPointPhonePrefix}-${this.mockData.lendingPointPhone}`
                    }
                ]
            },

            privacyLabel() {
                return '<a href="https://es.iqos.com/es/legal#politica-de-privacidad" target="_blank" class="q-link">' +
                    this.$T('i have read and accept the terms of use of the program and the privacy policy by Philip Morris Spain') + '</a>'
            },

            optionalLabel() {
                // return this.$T('')
                return this.$T('quiero recibir comunicaciones comerciales (incluyendo <b>llamadas</b> y email o medios de comunicación electrónica equivalentes) reservadas a miembros de myIQOS para estar informado de las novedades y servicios que me ayudaran a aprovechar al máximo mi experiencia con IQOS.')
            },

            guidedTrialLabel() {
                return this.$T('this consumer came from guided trial')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/termsAndConditions.vue